import React, {useState} from 'react';
import styled from 'styled-components';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {Drawer, Grid, Menu} from 'antd';
import {
    UserOutlined,
    ShoppingOutlined,
    IdcardOutlined,
    EnvironmentOutlined,
    StarOutlined,
    ClockCircleOutlined,
    TrophyOutlined,
    SwapOutlined,
    LockOutlined,
    LogoutOutlined,
    FileTextOutlined,
    MenuOutlined,
} from '@ant-design/icons';
import {
    WHITE,
    BORDER_GRAY,
    GREE_1,
} from '../../utils/colors';
import {useClientAuth} from '../../contexts/ClientAuthContext';
import useBreakPoints from "../../hooks/useBreakPoint";

const ProfileContainer = styled.div`
    display: flex;
    gap: 24px;
    min-height: 500px;
    flex-direction: ${props => props.flexDirection};
`;

const SidebarWrapper = styled.div`
    min-width: 150px;
    flex-shrink: 1;
    background: ${WHITE};
    border: 1px solid ${BORDER_GRAY};
    border-radius: 8px;
    overflow: hidden;

    .ant-menu {
        border-inline-end: none !important;
    }

    .ant-menu-item-selected {
        background: rgba(39, 92, 83, 0.08) !important;
        color: ${GREE_1} !important;
    }

    .ant-menu-item:hover {
        color: ${GREE_1} !important;
    }

    .ant-menu-item-selected::after {
        border-bottom-color: ${GREE_1} !important;
    }
`;

const ContentWrapper = styled.div`
    flex: 1;
    //width: 100%;
    background: ${WHITE};
    //background: red;
    border: 1px solid ${BORDER_GRAY};
    border-radius: 8px;
    padding: 32px;
    min-height: 400px;

    @media (max-width: 768px) {
        padding: 20px 16px;
    }
`;

const MobileMenuBar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    background: ${WHITE};
    border: 1px solid ${BORDER_GRAY};
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    
    
`;

const HamburgerBtn = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    color: ${GREE_1};
    display: flex;
    align-items: center;
    padding: 0;
`;

const MobileMenuLabel = styled.span`
    font-size: 15px;
    font-weight: 500;
    color: ${GREE_1};
`;

const menuItems = [
    {key: 'meus-dados', label: 'Meus dados', icon: <IdcardOutlined/>},
    {key: 'prescricoes', label: 'Prescrições', icon: <FileTextOutlined/>},
    {key: 'meus-pedidos', label: 'Meus pedidos', icon: <ShoppingOutlined/>},
    {key: 'meus-enderecos', label: 'Meus endereços', icon: <EnvironmentOutlined/>},
    {key: 'alterar-senha', label: 'Alterar senha', icon: <LockOutlined/>},
    {type: 'divider'},
    {key: 'sair', label: 'Sair', icon: <LogoutOutlined/>, danger: true},
];

const BASE_PATH = '/area-do-associado/loja/perfil';

export default function ShopProfileLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const {logout} = useClientAuth();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const {isLgBreakPoint} = useBreakPoints();

    const currentPath = location.pathname.replace(BASE_PATH, '').replace(/^\//, '');
    const selectedKey = currentPath || 'minha-conta';
    const selectedLabel = menuItems.find(item => item.key === selectedKey)?.label || 'Menu';

    const handleMenuClick = ({key}) => {
        setDrawerOpen(false);
        if (key === 'sair') {
            logout();
            return;
        }
        navigate(key === 'minha-conta' ? BASE_PATH : `${BASE_PATH}/${key}`);
    };

    const menu = (
        <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            items={menuItems}
            onClick={handleMenuClick}
            style={{padding: '8px 0'}}
        />
    );

    return (
        <ProfileContainer flexDirection={!isLgBreakPoint? 'column' : 'row'}>
            {!isLgBreakPoint ? (
                <>
                    <MobileMenuBar>
                        <HamburgerBtn onClick={() => setDrawerOpen(true)}>
                            <MenuOutlined/>
                        </HamburgerBtn>
                        <MobileMenuLabel>{selectedLabel}</MobileMenuLabel>
                    </MobileMenuBar>
                    <Drawer
                        title="Menu"
                        placement="left"
                        open={drawerOpen}
                        onClose={() => setDrawerOpen(false)}
                        width={280}
                        styles={{body: {padding: 0}}}
                    >
                        {menu}
                    </Drawer>
                </>
            ) : (
                <SidebarWrapper>{menu}</SidebarWrapper>
            )}
            <ContentWrapper>
                <Outlet/>
            </ContentWrapper>
        </ProfileContainer>
    );
}